export {
    appDataGridSx as catalogDataGridSx,
    appDataGridDefaultProps,
    appDataGridSlotProps,
    appSearchFieldSx as catalogSearchFieldSx,
    emptySelectionModel,
    mergeDataGridSx,
    selectionIds,
} from "../Helpers/dataGridStyles.js";

export const catalogPrimaryButtonSx = {
    textTransform: "none",
    fontWeight: 700,
    borderRadius: "10px",
    px: 1.75,
    boxShadow: "none",
    backgroundColor: "#0d9488",
    "&:hover": {
        backgroundColor: "#0f766e",
        boxShadow: "none",
    },
};

export const catalogQuietButtonSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    borderColor: "#e2e8f0",
    color: "#1c2430",
    backgroundColor: "#ffffff",
    "&:hover": {
        borderColor: "#cbd5e1",
        backgroundColor: "#f8fafc",
    },
    "&.Mui-disabled": {
        borderColor: "#eef2f6",
    },
};

export const catalogDangerButtonSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    borderColor: "#f5c4bd",
    color: "#e03e2d",
    backgroundColor: "#ffffff",
    "&:hover": {
        borderColor: "#e03e2d",
        backgroundColor: "#fff1ee",
    },
};
